import React from 'react';

const CookiePolicy = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1 className="page-title">Cookie Policy</h1>
        <p className="policy-date">Last updated: 1 January 2026</p>

        <section className="policy-section">
          <h2>1. Introduction</h2>
          <p>This Cookie Policy explains how World Financial Award Ltd ("we", "us", "our") uses cookies and similar technologies on our website. This policy is provided in compliance with the Privacy and Electronic Communications Regulations 2003 (PECR) and the UK GDPR.</p>
        </section>

        <section className="policy-section">
          <h2>2. What Are Cookies?</h2>
          <p>Cookies are small text files placed on your device when you visit a website. They are widely used to make websites work efficiently and to provide information to the owners of the site. Cookies can be "persistent" (remaining on your device until deleted) or "session" cookies (deleted when you close your browser).</p>
        </section>

        <section className="policy-section">
          <h2>3. Cookies We Use</h2>

          <h3>Strictly Necessary Cookies</h3>
          <p>These cookies are essential for the operation of our website. They include cookies that enable you to navigate the website and use its features. Without these cookies, services you have requested cannot be provided.</p>

          <h3>Analytical/Performance Cookies</h3>
          <p>These cookies allow us to recognise and count the number of visitors and to see how visitors move around our website. This helps us to improve the way our website works, for example by ensuring that users find what they are looking for easily.</p>

          <h3>Functionality Cookies</h3>
          <p>These cookies are used to recognise you when you return to our website. They enable us to personalise our content for you, remember your preferences (for example, your choice of language or region), and enhance your experience.</p>
        </section>

        <section className="policy-section">
          <h2>4. How to Manage Cookies</h2>
          <p>You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.</p>
          <p>Most browsers allow you to manage your cookie preferences. You can usually find these settings in the "Options" or "Preferences" menu of your browser. The following links may be helpful:</p>
          <ul>
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Cookie settings in Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" rel="noopener noreferrer">Cookie settings in Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/en-gb/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Cookie settings in Safari</a></li>
            <li><a href="https://support.microsoft.com/en-gb/microsoft-edge/delete-cookies-in-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Cookie settings in Microsoft Edge</a></li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>5. Third-Party Cookies</h2>
          <p>In some cases, we may use third-party cookies. These are set by a domain other than our website. We use third-party cookies for embedded content (such as YouTube videos) and analytical purposes. Please note that we do not control the use of these cookies and you should refer to the relevant third party's cookie policy for more information.</p>
        </section>

        <section className="policy-section">
          <h2>6. Changes to This Policy</h2>
          <p>We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated revision date.</p>
        </section>

        <section className="policy-section">
          <h2>7. Contact</h2>
          <p>If you have any questions about our use of cookies, please contact:<br />
          World Financial Award Ltd<br />
          Email: <a href="mailto:info@worldfinancialaward.com">info@worldfinancialaward.com</a><br />
          London, United Kingdom</p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
